import React, { useEffect, useState } from "react";
import {
	FormControl,
	Autocomplete,
	TextField,
	MenuItem,
	Grid,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { IProcurementMethod } from "models/ProcurementMethod/procurementMethodModel";

export type Props = {
	name: string;
	label: string;
	options: IProcurementMethod[];
};

export const CustomProcurementMethodSelect: React.FC<Props> = ({
	name,
	label,
	options,
}) => {
	const methods = useFormContext();
	const [value, setValue] = useState<IProcurementMethod | null>(null);
	const selectedValue = methods.watch(name);

	useEffect(() => {
		const item = options.find(
			(opt: IProcurementMethod) => opt.procurementMethodId === selectedValue
		);
		setValue(item ? item : null);
	}, [selectedValue, options]);

	return (
		<FormControl>
			<Controller
				control={methods.control}
				name={name}
				render={({ field: { onChange, ref }, fieldState: { error } }) => (
					<Autocomplete
						disablePortal
						options={[
							{
								procurementMethodId: -1,
								procurementMethodNumber: "",
								description: "Description",
								procurementMethodType: "Procurement Method",
								thresholdFrom: 0,
								thresholdTo: 0,
								itemAvailabilityId: 0,
								procurementMethodAbbreviation: "",
								procurementMethodCategory: "",
								validityPeriodInDays: 0,
								isTransversalContract: false,
							},
							...options,
						]}
						clearIcon={false}
						className="auto-complete-dialog"
						value={value}
						onChange={(
							_event: React.SyntheticEvent<Element, Event>,
							newValue: IProcurementMethod | null
						) => {
							onChange(newValue ? newValue.procurementMethodId : null);
						}}
						getOptionLabel={(option) =>
							`${option.procurementMethodCategory} (${option.description})`
						}
						isOptionEqualToValue={(option, value) =>
							option.procurementMethodId === value.procurementMethodId
						}
						getOptionDisabled={(option) => option.procurementMethodId === -1}
						renderOption={(props, option: IProcurementMethod) => (
							<MenuItem
								{...props}
								key={option.procurementMethodId}
								disabled={option.procurementMethodId === -1}
								className="table-responsive"
							>
								<Grid container spacing={1}>
									<Grid item xs={4}>
										{option.procurementMethodCategory}
									</Grid>
									<Grid item xs={8}>
										{option.description}
									</Grid>
								</Grid>
							</MenuItem>
						)}
						renderInput={(params) => (
							<TextField
								{...params}
								label={label}
								inputRef={ref}
								error={!!error}
								autoComplete="off"
								helperText={error ? error.message : null}
							/>
						)}
					/>
				)}
			/>
		</FormControl>
	);
};
